import { render, staticRenderFns } from "./AlbumLegacySyncDialog.vue?vue&type=template&id=3b64de2c&scoped=true"
import script from "./AlbumLegacySyncDialog.vue?vue&type=script&lang=js"
export * from "./AlbumLegacySyncDialog.vue?vue&type=script&lang=js"
import style0 from "./AlbumLegacySyncDialog.vue?vue&type=style&index=0&id=3b64de2c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64de2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b64de2c')) {
      api.createRecord('3b64de2c', component.options)
    } else {
      api.reload('3b64de2c', component.options)
    }
    module.hot.accept("./AlbumLegacySyncDialog.vue?vue&type=template&id=3b64de2c&scoped=true", function () {
      api.rerender('3b64de2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/album/AlbumLegacySyncDialog.vue"
export default component.exports